import { render } from "./SubmitTypeComponent.vue?vue&type=template&id=08637642&scoped=true"
import script from "./SubmitTypeComponent.vue?vue&type=script&lang=js"
export * from "./SubmitTypeComponent.vue?vue&type=script&lang=js"

import "./SubmitTypeComponent.vue?vue&type=style&index=0&id=08637642&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08637642"]])

export default __exports__